import React from "react";
import { Link as RouterLink } from "react-router-dom";

import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import ChartCard from "./ChartCard";
import KpiTile from "./KpiTile";
import { formatCurrency, formatDate, formatNumber } from "./dashboardUtils";

const WINDOWS = [
  { key: "next_7_days", label: "Arriving in the next 7 days" },
  { key: "next_30_days", label: "Arriving in the next 30 days" },
  { key: "next_90_days", label: "Arriving in the next 90 days" },
];

// Not tied to the selected date range: arrivals always look forward from
// today.
const UpcomingArrivals = ({ upcoming }) => {
  const { arrivals } = upcoming;

  const table = (
    <TableContainer style={{ maxHeight: 440 }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Order</TableCell>
            <TableCell>Check-in</TableCell>
            <TableCell>Check-out</TableCell>
            <TableCell>Guest</TableCell>
            <TableCell>Property</TableCell>
            <TableCell>Package</TableCell>
            <TableCell align="right">Nights</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell align="right">Balance due</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {arrivals.map((a) => (
            <TableRow key={a.order_id} hover>
              <TableCell>
                <Link component={RouterLink} to={`/sales/orders/${a.order_id}`}>
                  {`#${a.order_id}`}
                </Link>
              </TableCell>
              <TableCell>{formatDate(a.check_in)}</TableCell>
              <TableCell>{formatDate(a.check_out)}</TableCell>
              <TableCell>{a.customer_name || "—"}</TableCell>
              <TableCell>{a.property_name}</TableCell>
              <TableCell>
                {a.type === "condo" ? "Condo stay" : a.package_name || "—"}
              </TableCell>
              <TableCell align="right">{formatNumber(a.nights)}</TableCell>
              <TableCell align="right">{formatCurrency(a.booked)}</TableCell>
              <TableCell align="right">
                {a.balance_due > 0 ? (
                  <Typography variant="body2" color="error" component="span">
                    {formatCurrency(a.balance_due)}
                  </Typography>
                ) : (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="span"
                  >
                    Paid
                  </Typography>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <Grid container spacing={2}>
      {WINDOWS.map((w) => {
        const stats = upcoming[w.key];
        return (
          <Grid item xs={12} sm={4} key={w.key}>
            <KpiTile
              label={w.label}
              value={`${formatNumber(stats.orders)} orders`}
              hint={`${formatCurrency(stats.booked)} booked · ${formatCurrency(
                stats.balance_due
              )} still to collect`}
            />
          </Grid>
        );
      })}
      <Grid item xs={12}>
        <ChartCard
          title="Upcoming arrivals"
          subtitle="Next 90 days by check-in date"
          isEmpty={arrivals.length === 0}
          table={table}
        />
      </Grid>
    </Grid>
  );
};

export default UpcomingArrivals;
